import React, { useState, useEffect, useRef } from 'react';
import {
    Box, Button, TableBody, Card, CardContent, TableCell, TableContainer, Paper,
    TableHead, Grid, Breadcrumbs, CircularProgress, Table, TableRow, Link,
    Tooltip, Typography, ListItemText, Select, OutlinedInput, MenuItem,
    TextField, FormControl, InputLabel, Checkbox, Alert, Chip, Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoomMasterdropdata, getShiftMasterdropdata } from '../../Api/PropertyMst/Api';
import { useLocation } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useModulePermissions } from '../../GlobalFunction/useModulePermissions';
import dayjs from 'dayjs';
import axios from 'axios';
import {
    Refresh as RefreshIcon,
    Download as DownloadIcon,
    Print as PrintIcon,
    Visibility as VisibilityIcon
} from '@mui/icons-material';
import { selectGlobalProperty } from '../../redux/propertySlice';
import { useSelector } from 'react-redux';


const printStyles = `
    @media print {
        @page {
            size: landscape;
            margin: 0.5in;
        }
        body {
            background: white;
            font-size: 10pt;
        }
        .no-print {
            display: none !important;
        }
        .print-only {
            display: block !important;
        }
        .MuiTable-root {
            page-break-inside: auto;
            border-collapse: collapse;
            width: 100%;
        }
        .MuiTableHead-root {
            display: table-header-group;
        }
        .MuiTableBody-root {
            display: table-row-group;
        }
        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }
        th, td {
            border: 1px solid #000 !important;
            padding: 2px 4px !important;
            font-size: 8pt !important;
            background: white !important;
            color: black !important;
        }
        th {
            background-color: #f0f0f0 !important;
            font-weight: bold !important;
        }
        .MuiChip-root {
            border: 1px solid #000 !important;
            background: white !important;
            color: black !important;
        }
        .summary-row {
            background-color: #f5f5f5 !important;
            font-weight: bold !important;
        }
        .print-header {
            text-align: center;
            margin-bottom: 20px;
            font-size: 14pt;
            font-weight: bold;
        }
        .print-subheader {
            text-align: center;
            margin-bottom: 10px;
            font-size: 11pt;
        }
        .print-summary {
            margin-top: 20px;
            margin-bottom: 20px;
            padding: 10px;
            border: 1px solid #000;
            display: flex;
            justify-content: space-around;
            font-size: 10pt;
        }
        .sticky-cell {
            position: static !important;
        }
        [class*="sticky"] {
            position: static !important;
        }
        .MuiTableContainer-root {
            overflow: visible !important;
        }
    }
    
    .print-only {
        display: none;
    }
`;

const AttendanceReport = () => {
    const userId = sessionStorage.getItem('UserId');
    const location = useLocation();
    const navigate = useNavigate();
    const printRef = useRef();

    const [rows, setRows] = useState([]);
    const [groupedData, setGroupedData] = useState([]);
    const [dates, setDates] = useState([]);
    const [dropdownData, setDropdownData] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [selectedShifts, setSelectedShifts] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [monthData, setMonthData] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [year, setYear] = useState('');
    const [yearData, setYearData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summaryData, setSummaryData] = useState({
        totalPresent: 0,
        totalAbsent: 0,
        totalWorkers: 0,
        totalDays: 0
    });

    const Authorization = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;
    const globalProperty = useSelector(selectGlobalProperty);

    const getCurrentPermissions = () => {
        if (location.state?.permissions) {
            localStorage.setItem('userPermissions', JSON.stringify(location.state.permissions));
            return location.state.permissions;
        }
        const storedPermissions = localStorage.getItem('userPermissions');
        return storedPermissions ? JSON.parse(storedPermissions) : [];
    };
    const currentPermissions = getCurrentPermissions();
    const permissions = useModulePermissions("Attendance Report");

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const years = [
            currentYear - 1,
            currentYear,
            currentYear + 1,
        ];
        setYearData(years);
        setYear(currentYear);
    }, []);

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);
                    if (dropdownItems?.length > 0 && globalProperty) {
                        const defaultProperty = dropdownItems.find(p => p.id === globalProperty) || dropdownItems[0];
                        setSelectedProperty(defaultProperty);
                    }
                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };
        fetchDropdownData();
    }, [userId, globalProperty]);

    useEffect(() => {
        const fetchShiftData = async () => {
            try {
                const response = await getShiftMasterdropdata();
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.ShiftId,
                        name: item.ShiftName,
                    }));
                    setShiftData(dropdownItems);
                }
            } catch (error) {
                toast.error("Error fetching shift data");
            }
        };
        fetchShiftData();
    }, []);

    useEffect(() => {
        if (shiftData?.length > 0) {
            setSelectedShifts([shiftData[0].id]);
        }
    }, [shiftData]);

    useEffect(() => {
        const fetchMonthData = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}HkTargetCalendar/GetMstMonthDrp`, {},
                    {
                        headers: {
                            Authorization: `Bearer ${Authorization}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.MonthId,
                        name: item.MonthName,
                        fullName: `${item.MonthName}`
                    }));
                    dropdownItems.sort((a, b) => a.id - b.id);
                    setMonthData(dropdownItems);

                    const currentMonth = new Date().getMonth() + 1;
                    const currentMonthOption = dropdownItems.find(m => m.id === currentMonth);
                    if (currentMonthOption) {
                        setSelectedMonth(currentMonthOption);
                    }
                }
            } catch (error) {
                toast.error("Error fetching month data");
            }
        };
        fetchMonthData();
    }, []);

    const handleYearChange = (e, newValue) => {
        setYear(newValue);
    };

    const handlePropertyChange = (e, newValue) => {
        setSelectedProperty(newValue);
    };

    const handleMonthChange = (event, newValue) => {
        if (newValue) {
            setSelectedMonth(newValue);
            setDates([]);
            setRows([]);
            setGroupedData([]);
        }
    };

    const handleShiftChange = (event) => {
        const { value } = event.target;
        setSelectedShifts(typeof value === 'string' ? value.split(',') : value);
    };

    const processApiData = (apiData) => {
        if (!apiData || apiData.length === 0) return [];

        const workTypeMap = new Map();
        const dateSet = new Set();

        apiData.forEach(item => {
            const workTypeKey = `${item.HkWrkTypeId}-${item.HkWrkTypeName}`;
            if (!workTypeMap.has(workTypeKey)) {
                workTypeMap.set(workTypeKey, {
                    workTypeId: item.HkWrkTypeId,
                    workTypeName: item.HkWrkTypeName,
                    shifts: {}
                });
            }

            if (item.TargetDate) {
                dateSet.add(item.TargetDate.split('T')[0]);
            }
        });

        const sortedDates = Array.from(dateSet).sort();
        setDates(sortedDates);

        const groupedByWorkType = [];

        workTypeMap.forEach((workType, key) => {
            const shiftMap = new Map();

            apiData.forEach(item => {
                if (item.HkWrkTypeId === workType.workTypeId && item.ShiftId) {
                    const shiftKey = `${item.ShiftId}-${item.ShiftName}`;
                    if (!shiftMap.has(shiftKey)) {
                        shiftMap.set(shiftKey, {
                            shiftId: item.ShiftId,
                            shiftName: item.ShiftName,
                            dailyData: {},
                            totalPresent: 0,
                            totalAbsent: 0
                        });
                    }

                    const date = item.TargetDate.split('T')[0];
                    const shiftData = shiftMap.get(shiftKey);
                    shiftData.dailyData[date] = {
                        present: item.AttnWorker || 0,
                        absent: item.AbsWorker || 0,
                        target: item.TgHkTotal || 0,
                        actual: item.ActHkTotal || 0
                    };

                    shiftData.totalPresent += item.AttnWorker || 0;
                    shiftData.totalAbsent += item.AbsWorker || 0;
                }
            });

            const shifts = Array.from(shiftMap.values());

            groupedByWorkType.push({
                ...workType,
                shifts: shifts
            });
        });

        let totalPresent = 0;
        let totalAbsent = 0;
        let totalWorkers = 0;

        groupedByWorkType.forEach(workType => {
            workType.shifts.forEach(shift => {
                totalPresent += shift.totalPresent;
                totalAbsent += shift.totalAbsent;
                totalWorkers += (shift.totalPresent + shift.totalAbsent);
            });
        });

        setSummaryData({
            totalPresent,
            totalAbsent,
            totalWorkers,
            totalDays: sortedDates.length
        });

        return groupedByWorkType;
    };

    const fetchAttendanceData = async () => {
        if (!selectedProperty) {
            toast.warning("Please select a property");
            return;
        }
        if (!selectedMonth) {
            toast.warning("Please select a month");
            return;
        }
        if (!selectedShifts || selectedShifts.length === 0) {
            toast.warning("Please select at least one shift");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                PropId: selectedProperty.id,
                MonthNm: selectedMonth.name,
                YearNm: year,
                ShiftId: selectedShifts.join(','),
                Flag: "TRPT"
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}HkTargetCalendar/GetHkTargetCalendar`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${Authorization}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response?.data?.Status === 0) {
                const processedData = processApiData(response.data.Data);
                setGroupedData(processedData);
                setRows(response.data.Data);
            } else {
                toast.error(response?.data?.Message || "Error fetching data");
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            toast.error("Error fetching attendance data");
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        const printContent = printRef.current.innerHTML;
        const currentDate = dayjs().format('DD/MM/YYYY HH:mm:ss');
        const monthYear = selectedMonth ? `${selectedMonth.name} ${year}` : '';
        const propertyName = selectedProperty ? selectedProperty.name : '';

        printWindow.document.write(`
            <html>
                <head>
                    <title>Attendance Report - ${propertyName} - ${monthYear}</title>
                    <style>
                        ${printStyles}
                        body {
                            font-family: Arial, sans-serif;
                            padding: 20px;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                        }
                        .print-header h2 {
                            margin: 0;
                            color: #333;
                        }
                        .print-header h3 {
                            margin: 5px 0;
                            color: #666;
                        }
                        .print-header p {
                            margin: 5px 0;
                            color: #888;
                            font-size: 10pt;
                        }
                        .summary-cards {
                            display: flex;
                            justify-content: space-between;
                            margin: 20px 0;
                            gap: 10px;
                        }
                        .summary-card {
                            flex: 1;
                            border: 1px solid #ddd;
                            padding: 10px;
                            text-align: center;
                            background: #f9f9f9;
                        }
                        .summary-card .label {
                            font-size: 9pt;
                            color: #666;
                        }
                        .summary-card .value {
                            font-size: 14pt;
                            font-weight: bold;
                            color: #333;
                        }
                        table {
                            border-collapse: collapse;
                            width: 100%;
                            font-size: 8pt;
                        }
                        th, td {
                            border: 1px solid #000;
                            padding: 3px;
                            text-align: center;
                        }
                        th {
                            background: #e0e0e0;
                        }
                        .total-row {
                            background: #f0f0f0;
                            font-weight: bold;
                        }
                        .grand-total-row {
                            background: #d0d0d0;
                            font-weight: bold;
                        }
                    </style>
                </head>
                <body>
                    <div class="print-header">
                        <h2>Attendance Report</h2>
                        <h3>${propertyName} - ${monthYear}</h3>
                        <p>Generated on: ${currentDate}</p>
                    </div>
                    
                    <div class="summary-cards">
                        <div class="summary-card">
                            <div class="label">Total Days</div>
                            <div class="value">${summaryData.totalDays}</div>
                        </div>
                        <div class="summary-card">
                            <div class="label">Total Workers</div>
                            <div class="value">${summaryData.totalWorkers}</div>
                        </div>
                        <div class="summary-card">
                            <div class="label">Total Present</div>
                            <div class="value">${summaryData.totalPresent}</div>
                        </div>
                        <div class="summary-card">
                            <div class="label">Total Absent</div>
                            <div class="value">${summaryData.totalAbsent}</div>
                        </div>
                        <div class="summary-card">
                            <div class="label">Avg. Present/Day</div>
                            <div class="value">${(summaryData.totalPresent / (summaryData.totalDays || 1)).toFixed(1)}</div>
                        </div>
                    </div>
                    
                    ${printContent}
                    
                    <div style="margin-top: 30px; text-align: center; font-size: 8pt; color: #666;">
                        This is a system generated report
                    </div>
                </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
        }, 500);
    };

    const getPresentColor = (present, absent) => {
        const total = present + absent;
        if (total === 0) return '#f5f5f5';
        const ratio = present / total;
        if (ratio >= 0.8) return '#e8f5e8';
        if (ratio >= 0.5) return '#fff3e0';
        return '#ffebee';
    };

    const grandTotalPresent = groupedData.reduce((sum, workType) => 
        sum + workType.shifts.reduce((s, shift) => s + shift.totalPresent, 0), 0);
    
    const grandTotalAbsent = groupedData.reduce((sum, workType) => 
        sum + workType.shifts.reduce((s, shift) => s + shift.totalAbsent, 0), 0);
    
    const grandTotalWorkers = grandTotalPresent + grandTotalAbsent;
    const grandAvgPresent = dates.length > 0 ? (grandTotalPresent / dates.length).toFixed(1) : 0;

    return (
        <>
            <style>{printStyles}</style>
            <Box sx={{ maxWidth: "94vw", overflow: "hidden", padding: 1 }}>
                <Box sx={{ mb: 1 }} className="no-print">
                    <Breadcrumbs aria-label="breadcrumb" separator="›">
                        <Link underline="hover" color="#635bff" onClick={() => navigate('/dashboard')} sx={{ cursor: 'pointer' }}>
                            Home
                        </Link>
                        <Link underline="hover" color="#635bff" onClick={() => navigate('/reports/dailysummaryreport')} sx={{ cursor: 'pointer' }}>
                            Report
                        </Link>
                        <Typography color="text.primary">Attendance Report</Typography>
                    </Breadcrumbs>
                </Box>

                <Paper sx={{ p: 1.5, mb: 1.5 }} className="no-print">
                    <Grid container spacing={1.5} alignItems="center">
                        <Grid item xs={12} md={2.5}>
                            <Autocomplete
                                options={dropdownData}
                                getOptionLabel={(option) => option?.name || ''}
                                value={selectedProperty}
                                onChange={handlePropertyChange}
                                size="small"
                                renderInput={(params) => (
                                    <TextField {...params} label="Property" size="small" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                options={yearData}
                                getOptionLabel={(option) => `${option}`}
                                value={year}
                                onChange={handleYearChange}
                                size="small"
                                renderInput={(params) => (
                                    <TextField {...params} label="Year" size="small" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <Autocomplete
                                options={monthData}
                                getOptionLabel={(option) => option?.name || ''}
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                size="small"
                                renderInput={(params) => (
                                    <TextField {...params} label="Month" size="small" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={2.5}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="shift-checkbox-label">Shift</InputLabel>
                                <Select
                                    labelId="shift-checkbox-label"
                                    multiple
                                    value={selectedShifts}
                                    onChange={handleShiftChange}
                                    input={<OutlinedInput label="Shift" />}
                                    renderValue={(selected) => {
                                        const selectedNames = shiftData
                                            .filter((item) => selected.includes(item.id))
                                            .map((item) => item.name);
                                        return selectedNames.join(", ");
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: { maxHeight: 200 },
                                        },
                                    }}
                                >
                                    {shiftData.map((item) => (
                                        <MenuItem key={item.id} value={item.id} dense>
                                            <Checkbox checked={selectedShifts.includes(item.id)} size="small" />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                <Button
                                    variant="contained"
                                    startIcon={<RefreshIcon />}
                                    onClick={fetchAttendanceData}
                                    disabled={loading}
                                    size="small"
                                    sx={{
                                        height: "36px",
                                        backgroundColor: "#635bff",
                                        textTransform: "none",
                                        flex: 1,
                                        fontSize: "0.8rem"
                                    }}
                                >
                                    {loading ? <CircularProgress size={20} /> : "Get Data"}
                                </Button>

                                <Tooltip title="Print Report">
                                    <Button
                                        variant="outlined"
                                        startIcon={<PrintIcon />}
                                       onClick={handlePrint}
                                        size="small"
                                        sx={{ height: "36px", minWidth: "36px" }}
                                        disabled={groupedData.length === 0}
                                    >
                                        Print
                                    </Button>
                                </Tooltip>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

    
                {groupedData.length > 0 && (
                    <Paper sx={{ p: 1, mb: 1.5 }} className="no-print">
                        <Grid container spacing={1}>
                            <Grid item xs={2}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                    <Typography variant="caption" color="textSecondary">Total Days</Typography>
                                    <Typography variant="body2" fontWeight="bold">{summaryData.totalDays}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: '#e8f5e8', borderRadius: 1 }}>
                                    <Typography variant="caption" color="textSecondary">Total Workers</Typography>
                                    <Typography variant="body2" fontWeight="bold">{summaryData.totalWorkers}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: '#e8f5e8', borderRadius: 1 }}>
                                    <Typography variant="caption" color="textSecondary">Total Present</Typography>
                                    <Typography variant="body2" fontWeight="bold" color="#2e7d32">{summaryData.totalPresent}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: '#ffebee', borderRadius: 1 }}>
                                    <Typography variant="caption" color="textSecondary">Total Absent</Typography>
                                    <Typography variant="body2" fontWeight="bold" color="#c62828">{summaryData.totalAbsent}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: '#fff3e0', borderRadius: 1 }}>
                                    <Typography variant="caption" color="textSecondary">Present %</Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                        {((summaryData.totalPresent / (summaryData.totalWorkers || 1)) * 100).toFixed(1)}%
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={2}>
                                <Box sx={{ textAlign: 'center', p: 0.5, bgcolor: '#fff3e0', borderRadius: 1 }}>
                                    <Typography variant="caption" color="textSecondary">Avg/Day</Typography>
                                    <Typography variant="body2" fontWeight="bold">
                                        {(summaryData.totalPresent / (summaryData.totalDays || 1)).toFixed(1)}
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                )}

                <Paper sx={{ width: '100%', overflow: 'hidden' }} ref={printRef}>
                    <TableContainer sx={{ maxHeight: 'calc(100vh - 280px)' }}>
                        {loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                                <CircularProgress />
                            </Box>
                        ) : groupedData.length === 0 ? (
                            <Box sx={{ p: 4, textAlign: 'center' }}>
                                <Alert severity="info">
                                    No data available. Please select filters and click "Get Data"
                                </Alert>
                            </Box>
                        ) : (
                            <Table stickyHeader size="small" padding="none" sx={{ minWidth: 1200 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            rowSpan={2}
                                            sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#f5f5f5',
                                                borderRight: '1px solid #e0e0e0',
                                                minWidth: 100,
                                                maxWidth: 100,
                                                width: 100,
                                                position: 'sticky',
                                                left: 0,
                                                zIndex: 3,
                                                py: 0.5,
                                                px: 0.5,
                                                fontSize: '0.7rem'
                                            }}
                                        >
                                            Work Type
                                        </TableCell>
                                        <TableCell
                                            rowSpan={2}
                                            sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#f5f5f5',
                                                borderRight: '1px solid #e0e0e0',
                                                minWidth: 60,
                                                maxWidth: 60,
                                                width: 60,
                                                position: 'sticky',
                                                left: 100,
                                                zIndex: 3,
                                                py: 0.5,
                                                px: 0.25,
                                                fontSize: '0.8rem'
                                            }}
                                        >
                                            Shift
                                        </TableCell>

                                        {dates.map((date, index) => (
                                            <TableCell
                                                key={date}
                                                colSpan={2}
                                                align="center"
                                                sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#f5f5f5',
                                                    borderLeft: '1px solid #e0e0e0',
                                                    borderRight: '1px solid #e0e0e0',
                                                    minWidth: 50,
                                                    maxWidth: 50,
                                                    width: 50,
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 2,
                                                    py: 0.25,
                                                    px: 0.25,
                                                    fontSize: '0.65rem'
                                                }}
                                            >
                                                <Tooltip title={dayjs(date).format('dddd, DD MMMM YYYY')}>
                                                    <span>{dayjs(date).format('DD')}</span>
                                                </Tooltip>
                                            </TableCell>
                                        ))}

                                        <TableCell
                                            rowSpan={2}
                                            align="center"
                                            sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#e8f5e8',
                                                borderLeft: '2px solid #ccc',
                                                minWidth: 45,
                                                maxWidth: 45,
                                                width: 45,
                                                py: 0.25,
                                                px: 0.25,
                                                fontSize: '0.7rem'
                                            }}
                                        >
                                            P
                                        </TableCell>
                                        <TableCell
                                            rowSpan={2}
                                            align="center"
                                            sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#ffebee',
                                                minWidth: 45,
                                                maxWidth: 45,
                                                width: 45,
                                                py: 0.25,
                                                px: 0.25,
                                                fontSize: '0.7rem'
                                            }}
                                        >
                                            A
                                        </TableCell>
                                        <TableCell
                                            rowSpan={2}
                                            align="center"
                                            sx={{
                                                fontWeight: 'bold',
                                                backgroundColor: '#fff3e0',
                                                minWidth: 40,
                                                maxWidth: 40,
                                                width: 40,
                                                py: 0.25,
                                                px: 0.25,
                                                fontSize: '0.7rem'
                                            }}
                                        >
                                            Avg
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        {dates.map((date) => (
                                            <React.Fragment key={`sub-${date}`}>
                                                <TableCell
                                                    align="center"
                                                    sx={{
                                                        backgroundColor: '#e8f5e8',
                                                        color: '#2e7d32',
                                                        borderLeft: '1px solid #e0e0e0',
                                                        py: 0.125,
                                                        px: 0.125,
                                                        fontSize: '0.6rem',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    P
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    sx={{
                                                        backgroundColor: '#ffebee',
                                                        color: '#c62828',
                                                        borderRight: '1px solid #e0e0e0',
                                                        py: 0.125,
                                                        px: 0.125,
                                                        fontSize: '0.6rem',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    A
                                                </TableCell>
                                            </React.Fragment>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {groupedData.map((workType, wtIndex) => (
                                        <React.Fragment key={`wt-${workType.workTypeId}`}>
                                            {workType.shifts.map((shift, shiftIndex) => {
                                                const totalDays = dates.length;
                                                const avgPresent = totalDays > 0 ? (shift.totalPresent / totalDays).toFixed(1) : 0;

                                                return (
                                                    <TableRow
                                                        key={`${workType.workTypeId}-${shift.shiftId}`}
                                                        sx={{
                                                            '&:nth-of-type(even)': { backgroundColor: '#fafafa' },
                                                            height: 22
                                                        }}
                                                    >
                                                        <TableCell
                                                            sx={{
                                                                borderRight: '1px solid #e0e0e0',
                                                                position: 'sticky',
                                                                left: 0,
                                                                backgroundColor: 'inherit',
                                                                zIndex: 1,
                                                                py: 0.125,
                                                                px: 0.25,
                                                                fontSize: '0.65rem',
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis'
                                                            }}
                                                        >
                                                            {shiftIndex === 0 ? (
                                                                <Tooltip title={workType.workTypeName}>
                                                                    <span style={{ fontWeight: 600 }}>
                                                                        {workType.workTypeName.length > 15 
                                                                            ? `${workType.workTypeName.substring(0, 15)}...` 
                                                                            : workType.workTypeName}
                                                                    </span>
                                                                </Tooltip>
                                                            ) : null}
                                                        </TableCell>

                                                        <TableCell
                                                            sx={{
                                                                borderRight: '1px solid #e0e0e0',
                                                                position: 'sticky',
                                                                left: 100,
                                                                backgroundColor: 'inherit',
                                                                zIndex: 1,
                                                                py: 0.125,
                                                                px: 0.125,
                                                                fontSize: '0.7rem'
                                                            }}
                                                        >
                                                            <Chip
                                                                size="small"
                                                                label={shift.shiftName.length > 10 ? `${shift.shiftName.substring(0, 10)}...` : shift.shiftName}
                                                                variant="outlined"
                                                                sx={{
                                                                    height: 16,
                                                                    fontSize: '0.55rem',
                                                                    '& .MuiChip-label': { px: 0.10 }
                                                                }}
                                                            />
                                                        </TableCell>

                                                        {dates.map((date) => {
                                                            const dailyData = shift.dailyData[date] || { present: 0, absent: 0 };
                                                            const bgColor = getPresentColor(dailyData.present, dailyData.absent);

                                                            return (
                                                                <React.Fragment key={`${date}-${shift.shiftId}`}>
                                                                    <TableCell
                                                                        align="center"
                                                                        sx={{
                                                                            backgroundColor: bgColor,
                                                                            borderLeft: '1px solid #e0e0e0',
                                                                            py: 0.125,
                                                                            px: 0.125,
                                                                            fontSize: '0.6rem',
                                                                            width: 25,
                                                                            maxWidth: 25
                                                                        }}
                                                                    >
                                                                        {dailyData.present}
                                                                    </TableCell>
                                                                    <TableCell
                                                                        align="center"
                                                                        sx={{
                                                                            backgroundColor: bgColor,
                                                                            borderRight: '1px solid #e0e0e0',
                                                                            color: dailyData.absent > 0 ? '#f44336' : 'inherit',
                                                                            py: 0.125,
                                                                            px: 0.125,
                                                                            fontSize: '0.6rem',
                                                                            width: 25,
                                                                            maxWidth: 25
                                                                        }}
                                                                    >
                                                                        {dailyData.absent}
                                                                    </TableCell>
                                                                </React.Fragment>
                                                            );
                                                        })}

                                                        <TableCell
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                borderLeft: '2px solid #ccc',
                                                                backgroundColor: '#e8f5e8',
                                                                py: 0.125,
                                                                px: 0.125,
                                                                fontSize: '0.6rem',
                                                                width: 45,
                                                                maxWidth: 45
                                                            }}
                                                        >
                                                            {shift.totalPresent}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                backgroundColor: '#ffebee',
                                                                color: '#f44336',
                                                                py: 0.125,
                                                                px: 0.125,
                                                                fontSize: '0.6rem',
                                                                width: 45,
                                                                maxWidth: 45
                                                            }}
                                                        >
                                                            {shift.totalAbsent}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                backgroundColor: '#fff3e0',
                                                                py: 0.125,
                                                                px: 0.125,
                                                                fontSize: '0.6rem',
                                                                width: 40,
                                                                maxWidth: 40
                                                            }}
                                                        >
                                                            {avgPresent}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}

                                            {workType.shifts.length > 0 && (
                                                <TableRow sx={{ backgroundColor: '#f5f5f5', height: 22 }}>
                                                    <TableCell
                                                        colSpan={2}
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            borderRight: '1px solid #e0e0e0',
                                                            position: 'sticky',
                                                            left: 0,
                                                            backgroundColor: '#f5f5f5',
                                                            zIndex: 1,
                                                            py: 0.125,
                                                            px: 0.25,
                                                            fontSize: '0.6rem'
                                                        }}
                                                    >
                                                        <span style={{ color: '#635bff', fontWeight: 600 }}>
                                                            {workType.workTypeName.length > 10 ? `${workType.workTypeName.substring(0, 12)}..` : workType.workTypeName} - Total
                                                        </span>
                                                    </TableCell>

                                                    {dates.map((date) => {
                                                        const totalPresent = workType.shifts.reduce((sum, shift) =>
                                                            sum + (shift.dailyData[date]?.present || 0), 0);
                                                        const totalAbsent = workType.shifts.reduce((sum, shift) =>
                                                            sum + (shift.dailyData[date]?.absent || 0), 0);

                                                        return (
                                                            <React.Fragment key={`sum-${date}`}>
                                                                <TableCell
                                                                    align="center"
                                                                    sx={{
                                                                        fontWeight: 'bold',
                                                                        borderLeft: '1px solid #e0e0e0',
                                                                        py: 0.125,
                                                                        px: 0.125,
                                                                        fontSize: '0.6rem',
                                                                        width: 25,
                                                                        maxWidth: 25
                                                                    }}
                                                                >
                                                                    {totalPresent}
                                                                </TableCell>
                                                                <TableCell
                                                                    align="center"
                                                                    sx={{
                                                                        fontWeight: 'bold',
                                                                        borderRight: '1px solid #e0e0e0',
                                                                        color: totalAbsent > 0 ? '#f44336' : 'inherit',
                                                                        py: 0.125,
                                                                        px: 0.125,
                                                                        fontSize: '0.6rem',
                                                                        width: 25,
                                                                        maxWidth: 25
                                                                    }}
                                                                >
                                                                    {totalAbsent}
                                                                </TableCell>
                                                            </React.Fragment>
                                                        );
                                                    })}

                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            borderLeft: '2px solid #ccc',
                                                            backgroundColor: '#e8f5e8',
                                                            py: 0.125,
                                                            px: 0.125,
                                                            fontSize: '0.6rem',
                                                            width: 45,
                                                            maxWidth: 45
                                                        }}
                                                    >
                                                        {workType.shifts.reduce((sum, s) => sum + s.totalPresent, 0)}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            backgroundColor: '#ffebee',
                                                            py: 0.125,
                                                            px: 0.125,
                                                            fontSize: '0.6rem',
                                                            width: 45,
                                                            maxWidth: 45
                                                        }}
                                                    >
                                                        {workType.shifts.reduce((sum, s) => sum + s.totalAbsent, 0)}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            backgroundColor: '#fff3e0',
                                                            py: 0.125,
                                                            px: 0.125,
                                                            fontSize: '0.6rem',
                                                            width: 40,
                                                            maxWidth: 40
                                                        }}
                                                    >
                                                        {(workType.shifts.reduce((sum, s) => sum + s.totalPresent, 0) / dates.length).toFixed(1)}
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </React.Fragment>
                                    ))}

                                    {/* Grand Total Row */}
                                    {groupedData.length > 0 && (
                                        <TableRow sx={{ backgroundColor: '#e0e0e0', height: 24 }}>
                                            <TableCell
                                                colSpan={2}
                                                sx={{
                                                    fontWeight: 'bold',
                                                    borderRight: '1px solid #e0e0e0',
                                                    position: 'sticky',
                                                    left: 0,
                                                    backgroundColor: '#e0e0e0',
                                                    zIndex: 1,
                                                    py: 0.25,
                                                    px: 0.5,
                                                    fontSize: '0.7rem'
                                                }}
                                            >
                                                GRAND TOTAL
                                            </TableCell>

                                            {dates.map((date) => {
                                                const totalPresent = groupedData.reduce((sum, wt) => 
                                                    sum + wt.shifts.reduce((s, shift) => 
                                                        s + (shift.dailyData[date]?.present || 0), 0), 0);
                                                const totalAbsent = groupedData.reduce((sum, wt) => 
                                                    sum + wt.shifts.reduce((s, shift) => 
                                                        s + (shift.dailyData[date]?.absent || 0), 0), 0);

                                                return (
                                                    <React.Fragment key={`grand-${date}`}>
                                                        <TableCell
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                borderLeft: '1px solid #e0e0e0',
                                                                py: 0.125,
                                                                px: 0.125,
                                                                fontSize: '0.65rem',
                                                                width: 25,
                                                                maxWidth: 25
                                                            }}
                                                        >
                                                            {totalPresent}
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                borderRight: '1px solid #e0e0e0',
                                                                color: totalAbsent > 0 ? '#c62828' : 'inherit',
                                                                py: 0.125,
                                                                px: 0.125,
                                                                fontSize: '0.65rem',
                                                                width: 25,
                                                                maxWidth: 25
                                                            }}
                                                        >
                                                            {totalAbsent}
                                                        </TableCell>
                                                    </React.Fragment>
                                                );
                                            })}

                                            <TableCell
                                                align="center"
                                                sx={{
                                                    fontWeight: 'bold',
                                                    borderLeft: '2px solid #ccc',
                                                    backgroundColor: '#c8e6c9',
                                                    py: 0.125,
                                                    px: 0.125,
                                                    fontSize: '0.7rem',
                                                    width: 45,
                                                    maxWidth: 45
                                                }}
                                            >
                                                {grandTotalPresent}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#ffcdd2',
                                                    py: 0.125,
                                                    px: 0.125,
                                                    fontSize: '0.7rem',
                                                    width: 45,
                                                    maxWidth: 45
                                                }}
                                            >
                                                {grandTotalAbsent}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                sx={{
                                                    fontWeight: 'bold',
                                                    backgroundColor: '#ffe0b2',
                                                    py: 0.125,
                                                    px: 0.125,
                                                    fontSize: '0.7rem',
                                                    width: 40,
                                                    maxWidth: 40
                                                }}
                                            >
                                                {grandAvgPresent}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        )}
                    </TableContainer>
                </Paper>

                <ToastContainer position="top-right" autoClose={3000} />
            </Box>
        </>
    );
};

export default AttendanceReport;